import { render, staticRenderFns } from "./updateBaseMassegeModal.vue?vue&type=template&id=ca129156&scoped=true"
import script from "./updateBaseMassegeModal.vue?vue&type=script&lang=js"
export * from "./updateBaseMassegeModal.vue?vue&type=script&lang=js"
import style0 from "./updateBaseMassegeModal.vue?vue&type=style&index=0&id=ca129156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca129156",
  null
  
)

export default component.exports